import 'react';

import GenericInputWrapper from './generic-wrapper/generic-input-wrapper';

export const GenericTextAreaInput = (
  {
    ref,
    ...props
  }
) => {
  return <GenericInputWrapper {...props} ref={ref} as="textarea" />;
};

GenericTextAreaInput.displayName = 'GenericTextAreaInput';

export default GenericTextAreaInput;
